export enum InvestorType {
  RetailInvestor = 1,
  AngelInvestor = 2,
  SophisticatedInvestor = 3,
}
